import { formatCurrencyGbp, formatNumber } from "./calculations";

function DiffCell({ value, kind = "number" }) {
  const positive = value >= 0;
  const cls = positive ? "text-lime-700" : "text-red-700";
  const rendered = kind === "currency" ? formatCurrencyGbp(value) : formatNumber(value, 1);
  return <span className={`font-semibold ${cls}`}>{rendered}</span>;
}

export default function ComparisonTable({ values, calc }) {
  const conventional = calc.conventional;
  const talent = calc.talent;
  const talentPoolCost = calc.summary.talentPoolCostPerCampaign;
  const netValue = calc.summary.perCampaignNetValue;
  const rows = [
    ["People requiring human review", conventional.reviewVolume, talent.reviewVolume, conventional.reviewVolume - talent.reviewVolume, "number"],
    ["Candidates sent to operational sift", Number(values.conventionalOperationalShortlist), Number(values.talentOperationalShortlist), Number(values.conventionalOperationalShortlist) - Number(values.talentOperationalShortlist), "number"],
    ["Candidates interviewed", conventional.interviewed, talent.interviewed, conventional.interviewed - talent.interviewed, "number"],
    ["Interview panel-days", conventional.interviewDays, talent.interviewDays, conventional.interviewDays - talent.interviewDays, "number"],
    ["Recruitment or HR hours", conventional.recruitmentHours, talent.recruitmentHours, conventional.recruitmentHours - talent.recruitmentHours, "number"],
    ["Operational manager hours", conventional.operationalHours, talent.operationalHours, conventional.operationalHours - talent.operationalHours, "number"],
    ["Total staff-hours", conventional.totalStaffHours, talent.totalStaffHours, conventional.totalStaffHours - talent.totalStaffHours, "number"],
    ["Internal labour value", conventional.internalLabourValue, talent.internalLabourValue, conventional.internalLabourValue - talent.internalLabourValue, "currency"],
    ["Talent Pool cost per campaign", 0, talentPoolCost, -talentPoolCost, "currency"],
    ["Net value per campaign", 0, netValue, netValue, "currency"],
    ["Cost per appointment", conventional.costPerAppointment, talent.costPerAppointment, conventional.costPerAppointment - talent.costPerAppointment, "currency"],
  ];

  return (
    <section className="rounded-xl border border-border bg-card p-4 md:p-5">
      <h3 className="font-display font-bold text-xl text-ink">Route comparison</h3>
      <p className="mt-2 text-xs text-muted-foreground md:hidden">Scroll horizontally to view the full comparison.</p>
      <div className="mt-3 md:mt-4 overflow-x-auto -mx-2 px-2">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-sand">
            <tr className="text-left">
              <th className="px-3 py-2 text-xs uppercase tracking-wider text-ink">Measure</th>
              <th className="px-3 py-2 text-xs uppercase tracking-wider text-ink">Conventional</th>
              <th className="px-3 py-2 text-xs uppercase tracking-wider text-ink">Talent pool</th>
              <th className="px-3 py-2 text-xs uppercase tracking-wider text-ink">Difference</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, conventionalValue, talentValue, diff, kind]) => (
              <tr key={label} className="border-t border-border">
                <td className="px-3 py-2 text-ink font-medium">{label}</td>
                <td className="px-3 py-2 text-muted-foreground">
                  {kind === "currency" ? formatCurrencyGbp(conventionalValue) : formatNumber(conventionalValue, 1)}
                </td>
                <td className="px-3 py-2 text-muted-foreground">
                  {kind === "currency" ? formatCurrencyGbp(talentValue) : formatNumber(talentValue, 1)}
                </td>
                <td className="px-3 py-2"><DiffCell value={diff} kind={kind} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-muted-foreground">
        Interview panel-days are panel-day equivalents calculated from interview volume and candidates per interview day. Employers may still need to book complete calendar interview days.
      </p>
    </section>
  );
}
